import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e270800"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "历史搜索", -1))
const _hoisted_3 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_4 = {
  key: 1,
  class: "no-info"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("加载失败，请")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  ref: "scrollWrapper",
  class: "ul-block"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["searchStockSelectwrap", _ctx.theme])
  }, [
    _createVNode(_component_a_input, {
      class: "input-wrapper",
      ref: "askingselect",
      id: "askingInput",
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onFocus: _ctx.focusSelect,
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.blurSelect())),
      onKeydown: _ctx.cancelArrowUp,
      onKeyup: _ctx.inputKeyup,
      onInput: _ctx.searchValue,
      placeholder: "搜索课程"
    }, {
      prefix: _withCtx(() => [
        _createVNode(_component_SearchOutlined)
      ]),
      suffix: _withCtx(() => [
        _withDirectives(_createVNode(_component_CloseCircleFilled, {
          class: "clearselect",
          onClick: _ctx.cleartagsCall
        }, null, 8, ["onClick"]), [
          [_vShow, _ctx.value.length]
        ])
      ]),
      _: 1
    }, 8, ["value", "onFocus", "onKeydown", "onKeyup", "onInput"]),
    _withDirectives(_createElementVNode("section", {
      class: "searchlist",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.preventBlur && _ctx.preventBlur(...args)))
    }, [
      _createElementVNode("ul", {
        onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handlekeyFn($event)))
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args)))
          }, [
            _createVNode(_component_DeleteOutlined)
          ])
        ], 512), [
          [_vShow, !_ctx.value.length && (_ctx.historyData||[]).length !== 0]
        ]),
        ((_ctx.selectOption||[]).length===0 && !_ctx.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "请输入课程名称"))
          : _createCommentVNode("", true),
        ((_ctx.selectOption||[]).length===0 && _ctx.value.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.errorRequest)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reRequest && _ctx.reRequest(...args)))
                    }, "刷新")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "未找到相关内容"))
            ]))
          : _createCommentVNode("", true),
        ((_ctx.selectOption||[]).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOption, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.Id,
                  class: _normalizeClass({'active': _ctx.activeLi === item.Id}),
                  onClick: ($event: any) => (_ctx.handleChange($event, item))
                }, [
                  _withDirectives(_createElementVNode("span", {
                    innerHTML: _ctx.highlightKeywords(item.courseName, _ctx.value)
                  }, null, 8, _hoisted_10), [
                    [_directive_widthoverflowtitle, item.courseName]
                  ])
                ], 10, _hoisted_9))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ], 32)
    ], 512), [
      [_vShow, _ctx.showDropdown]
    ])
  ], 2))
}